<div class="aligned-items" [class.justified-items]="isJustified">
    <div *ngFor="let ea of buttons; index as i;">
        <button  [igxButton]="getPressedStatus(i)" class="square-button" (click)="onClicked(i)" >
            <igx-icon *ngIf="ea.icon !== ''">{{ea.icon}}</igx-icon>
            <span *ngIf="ea.text !== ''">{{ea.text}}</span>
        </button>
    </div>
</div>